// Pure calendar data helpers — extracted so date-range/month navigation logic is unit-testable.
// All dates are handled as UTC "YYYY-MM-DD" / "YYYY-MM" strings to stay timezone-stable.

/** Group events by their `date` field. Plain-object Map equivalent (never .setdefault). */
export const groupEventsByDate = (events) => {
  const byDate = {};
  (events || []).forEach((e) => {
    if (!e || !e.date) return;
    if (!Object.prototype.hasOwnProperty.call(byDate, e.date)) byDate[e.date] = [];
    byDate[e.date].push(e);
  });
  return byDate;
};

/** Events visible after type filters. `hidden` is a Set of type keys. */
export const filterVisibleEvents = (events, hidden) =>
  (events || []).filter((e) => !(hidden && hidden.has(e.type)));

/** Shift a "YYYY-MM" month string by delta months, safe across year boundaries. */
export const shiftMonth = (month, delta) => {
  const [y, m] = month.split("-").map(Number);
  return new Date(Date.UTC(y, m - 1 + delta, 1)).toISOString().slice(0, 7);
};

/** Month grid cells: leading nulls (Monday-first) then "YYYY-MM-DD" strings. */
export const buildMonthGrid = (month) => {
  const [y, m] = month.split("-").map(Number);
  const daysInMonth = new Date(Date.UTC(y, m, 0)).getUTCDate();
  const first = new Date(Date.UTC(y, m - 1, 1));
  const lead = (first.getUTCDay() + 6) % 7;
  const cells = [];
  for (let i = 0; i < lead; i++) cells.push(null);
  for (let d = 1; d <= daysInMonth; d++) cells.push(`${month}-${String(d).padStart(2, "0")}`);
  return cells;
};

/** The 7 "YYYY-MM-DD" dates (Mon–Sun) of the week containing `selected` (or the month's 1st). */
export const buildWeekDays = (selected, month) => {
  const [y, m] = month.split("-").map(Number);
  const base = selected && selected.startsWith(month) ? new Date(`${selected}T00:00:00Z`) : new Date(Date.UTC(y, m - 1, 1));
  const monday = new Date(base);
  monday.setUTCDate(base.getUTCDate() - ((base.getUTCDay() + 6) % 7));
  return Array.from({ length: 7 }, (_, i) => {
    const d = new Date(monday);
    d.setUTCDate(monday.getUTCDate() + i);
    return d.toISOString().slice(0, 10);
  });
};

/** "January 2026"-style label for a month string. */
export const monthLabel = (month) =>
  new Date(`${month}-15T00:00:00Z`).toLocaleString(undefined, { month: "long", year: "numeric", timeZone: "UTC" });

/** Per-type event counts for the filter pills. */
export const countByType = (events) => {
  const counts = {};
  (events || []).forEach((e) => {
    if (!e || !e.type) return;
    counts[e.type] = (counts[e.type] || 0) + 1;
  });
  return counts;
};
